// extracted by extract-css-chunks-webpack-plugin
module.exports = {"appleButton":"_253mOT","appleIconContainer":"_37ayPs"};